import { Directive, Input } from '@angular/core';

import { EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { groupBy, values } from 'lodash-es';

import { BaseOptionRendererDirective } from './base-option-renderer.directive';

@Directive({
    selector: '[msOptionGroupRenderer]',
    exportAs: 'msOptionGroupRendererExport',
})
export class OptionGroupRendererDirective extends BaseOptionRendererDirective {
    @Input() optionGroup: EventOptionGroup;
    protected getColumnsSettings(): { maxColumns: number; oddColumns: boolean } {
        const options = groupBy(this.optionGroup.options, (option) => option.optionGroupId);
        const grouped = values(options);
        let maxColumns = this.maxColumns;
        let oddColumns = false;

        // balanced markets come in touples
        const balanced = grouped.every((optionGroup) => optionGroup.length === 2);

        // for balanced option groups we want to se them side by side
        // always so maximum two columns and also fallback
        // for option groups with 4 options
        if (balanced || this.optionGroup.options.length === 4 || this.optionGroup.balanced) {
            maxColumns = 2;
        }

        // for option groups containing 3 options like double change or 3 way result
        // we always display them in single or triple column
        oddColumns = grouped.length === 1 && grouped[0].length === 3;

        return { maxColumns, oddColumns };
    }
}
